import PropTypes from 'prop-types';
import React from 'react';
import { map, isEmpty, find } from 'lodash';
import Types from './AccessorialRatesTypes';
import { Grid, Row, Col, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

export default class AccessorialRatesPropsEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleNameChange() {
        return (e) => {
            this.props.onChange('name', e.target.value);
        };
    }

    handleTypeChange() {
        return (e) => {
            const type = e.target.value;
            this.props.onChange('type', type);
            this.props.onChange('description', find(Types, item => item.value === type).description);
        };
    }

    validateName(name) {
        if (isEmpty(name)) {
            return 'error';
        }
        return '';
    }

    render() {
        const accessorialRate = this.props.accessorialRate || {};
        return (
          <Grid fluid>
            <Row className="show-grid">
              <Col xs={4}>
               <FormGroup>
                  <ControlLabel>Accessorial Name</ControlLabel>
                  <FormControl
                    type="text"
                    defaultValue={accessorialRate.name}
                    onChange={this.handleNameChange()}
                    bsStyle={this.validateName(accessorialRate.name)}
                  />
                </FormGroup>
              </Col>
              <Col xs={4}>
               <FormGroup>
                  <ControlLabel>Type</ControlLabel>
                  <FormControl
                    componentClass="select"
                    defaultValue={accessorialRate.type}
                    onChange={this.handleTypeChange()}>
                    {map(Types, (type, index) => (
                        <option value={type.value} key={`type-${index}`}>{type.name}</option>))}
                  </FormControl>
                </FormGroup>
              </Col>
            </Row>
          </Grid>
        );
    }
}

AccessorialRatesPropsEditor.propTypes = {
    accessorialRate: PropTypes.object,
    onChange: PropTypes.func,
};
